import { combineReducers } from 'redux';
import environmentReducer from './reducers/environment';
import gridReducer from './reducers/grid';
import manifestReducer from './reducers/manifest';
import userInfoReducer from './reducers/userInfo';
import authReducer from './reducers/auth';
import modalReducer from './reducers/modal';
var rootReducer = combineReducers({
  environment: environmentReducer,
  userInfo: userInfoReducer,
  grid: gridReducer,
  manifest: manifestReducer,
  auth: authReducer,
  modal: modalReducer
});
export default rootReducer;